// Telefon asistanı aramalarının ekran adları (Koç Gözlem ve Sistem Ayarları → Telefon Asistanı → Son görüşmeler ortak)
export const ARAMA_DURUM: Record<string, string> = {
  QUEUED: "sırada", DIALING: "aranıyor", ANSWERED: "görüşülüyor", DONE: "görüşüldü", NO_ANSWER: "açmadı",
  BUSY: "meşgul", VOICEMAIL: "telesekreter", FAILED: "kurulamadı", CALLBACK: "geri aranmak istedi", PARENT: "velisi açtı",
  WRONG_NUMBER: "yanlış numara", REFUSED: "konuşmak istemedi",
};
export const SONUC_AD: Record<string, string> = {
  KONUSULDU: "konuşuldu", GERI_ARA: "geri aranmak istedi", VELI: "velisi açtı", YANLIS_NUMARA: "yanlış numara",
  TELESEKRETER: "telesekreter", REDDETTI: "konuşmak istemedi",
};
// Arama türü: koç aramaları + 25 Eki akademi aramaları
export const ARAMA_TUR: Record<string, string> = {
  OTOMATIK: "koç (otomatik)", OGRETMEN: "öğretmen", TEST: "test", ILK_ZIYARET: "ilk ziyaret", BAG: "akademi", GELEN: "geri aradı",
};
export const SMS_AD: Record<string, string> = { giris: "giriş", paket: "paket", yorum: "Google yorum" };
export const MEMNUNIYET_AD: Record<string, string> = { MEMNUN: "memnun", KARARSIZ: "kararsız", MEMNUN_DEGIL: "memnun değil" };
